// module imports
// import $ from "jquery";
//
// Main
//

// ...

document.addEventListener("DOMContentLoaded", function () {
  function initSelectAnrede() {
    const sel = document.querySelector("select.anrede") || document.querySelector("#nf-field-5");

    if (!sel) {
      // Element noch nicht da, nochmal versuchen
      setTimeout(initSelectAnrede, 100);
      return;
    }

    function update() {
      if (sel.value === "" || sel.selectedIndex === 0) {
        // Placeholder ist ausgewählt
        sel.classList.remove("has-value");
        sel.classList.add("is-placeholder");
      } else {
        // Eine echte Option ist ausgewählt
        sel.classList.add("has-value");
        sel.classList.remove("is-placeholder");
      }
    }

    // Event Listener hinzufügen
    sel.addEventListener("change", update);

    // Initial ausführen
    update();
  }

  // Starte die Initialisierung
  initSelectAnrede();

  const downloadContainers = document.querySelectorAll('[id^="downloads-container-"]');

  downloadContainers.forEach((container) => {
    const loadMoreBtn = container.querySelector(".load-more-downloads");
    if (!loadMoreBtn) return;

    const allYears = JSON.parse(loadMoreBtn.dataset.allYears || "[]");
    let visibleYears = JSON.parse(loadMoreBtn.dataset.visibleYears || "[]");

    loadMoreBtn.addEventListener("click", function () {
      const nextYear = this.getAttribute("data-next-year");

      // Alle Downloads des nächsten Jahres in DIESEM Container anzeigen
      const yearDownloads = container.querySelectorAll(`[data-year="${nextYear}"]`);

      yearDownloads.forEach((download) => {
        download.classList.remove("hidden");
      });

      // Jahr zu den sichtbaren hinzufügen
      visibleYears.push(nextYear);

      // Nächstes Jahr für den Button finden
      let nextYearToShow = null;
      for (let year of allYears) {
        if (!visibleYears.includes(year)) {
          nextYearToShow = year;
          break;
        }
      }

      // Button aktualisieren oder verstecken
      if (nextYearToShow) {
        this.setAttribute("data-next-year", nextYearToShow);
        this.querySelector("span").textContent = `Mehr laden`;
      } else {
        this.style.display = "none";
      }
    });
  });

  // Hamburger Menu Funktionalitä
  const hamburger = document.querySelector(".hamburger");
  const mobileMenu = document.querySelector(".mobile-menu");
  const searchIcon = document.getElementById("mobileSearchIcon"); // Das Such-SVG
  const mobileMenuLinks = document.querySelectorAll(".mobile-menu-link.has-children");
  const mobileSubmenus = document.querySelectorAll(".mobile-submenu");
  const mobileBackBtns = document.querySelectorAll(".mobile-back-btn");

  if (hamburger) {
    hamburger.addEventListener("click", function () {
      // Toggle active class für Animation
      this.classList.toggle("is-active");

      // Toggle mobile menu visibility
      if (mobileMenu) {
        mobileMenu.classList.toggle("active");
      }

      // Such-Icon verstecken/zeigen
      if (searchIcon) {
        setTimeout(() => {
          searchIcon.style.display = this.classList.contains("is-active") ? "none" : "block";
        }, 200); // Warte auf die Hamburger-Animation
      }

      // Body scroll verhindern wenn Menü offen
      document.body.classList.toggle("menu-open");
    });
  }

  // Submenu Links
  mobileMenuLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();

      const menuId = this.getAttribute("data-menu-id");
      const targetSubmenu = document.querySelector(`[data-parent-id="${menuId}"]`);

      if (targetSubmenu) {
        // Hide all submenus
        mobileSubmenus.forEach((submenu) => {
          submenu.classList.remove("active");
          submenu.style.display = "none";
        });

        // Show target submenu
        targetSubmenu.style.display = "block";
        setTimeout(() => {
          targetSubmenu.classList.add("active");
          mobileMenu.classList.add("submenu-active");
        }, 10);
      }
    });
  });

  // Back Buttons
  mobileBackBtns.forEach((btn) => {
    btn.addEventListener("click", function () {
      const submenu = this.closest(".mobile-submenu");

      if (submenu) {
        submenu.classList.remove("active");
        mobileMenu.classList.remove("submenu-active");

        setTimeout(() => {
          submenu.style.display = "none";
        }, 300);
      }
    });
  });

  // Close menu when clicking outside or on links without children
  document.addEventListener("click", function (e) {
    if (mobileMenu && mobileMenu.classList.contains("active")) {
      // Check if click is on a regular link (not has-children)
      if (
        e.target.matches(".mobile-menu-link:not(.has-children)") ||
        e.target.matches(".nebenmenue") ||
        e.target.matches(".mobile-submenu a")
      ) {
        // Close menu
        hamburger.classList.remove("is-active");
        mobileMenu.classList.remove("active", "submenu-active");
        document.body.classList.remove("menu-open");
        mobilePadding.classList.add("pt-[62px]");

        // Reset submenus
        mobileSubmenus.forEach((submenu) => {
          submenu.classList.remove("active");
          submenu.style.display = "none";
        });
      }
    }
  });
  // Beim Laden prüfen ob Overlay-Scrollbar oder klassische Scrollbar verwendet wird
  function checkScrollbarWidth() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (scrollbarWidth > 0) {
      // Klassischer Scrollbar vorhanden
      document.documentElement.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
    } else {
      // Overlay Scrollbar
      document.documentElement.style.setProperty("--scrollbar-width", "0px");
    }
  }
  checkScrollbarWidth();
  window.addEventListener("resize", checkScrollbarWidth);

  checkScrollbarWidth();
});

// Alternative: Falls Ninja Forms ein Event auslöst
document.addEventListener("nfFormReady", function () {
  const sel = document.querySelector("#nf-field-5");
  if (sel) {
    function update() {
      if (sel.value === "" || sel.selectedIndex === 0) {
        sel.classList.add("is-placeholder");
        sel.classList.remove("has-value");
      } else {
        sel.classList.add("has-value");
        sel.classList.remove("is-placeholder");
      }
    }

    sel.addEventListener("change", update);
    update();
  }
});

// FLICKITY SLIDER
document.addEventListener("DOMContentLoaded", function () {
  const carousel = document.getElementById("image-gallery-carousel");
  const track = document.getElementById("carousel-track");
  const prevBtn = document.getElementById("carousel-prev-btn");
  const nextBtn = document.getElementById("carousel-next-btn");
  const dotsContainer = document.getElementById("custom-dots");

  if (!carousel || !track || !dotsContainer) {
    return;
  }

  const slides = track.querySelectorAll(".gallery-slide");
  const totalSlides = slides.length;
  let currentSlide = 0;
  let isAnimating = false;

  if (totalSlides === 0) {
    console.error("No slides found");
    return;
  }

  // Initialize carousel
  function initCarousel() {
    // Mark container as loaded
    carousel.classList.add("loaded");

    // Set initial position
    updateSlidePosition(false);

    // Create dots
    createDots();

    // Update button states
    updateButtons();
  }

  // Create page dots
  function createDots() {
    dotsContainer.innerHTML = "";
    for (let i = 0; i < totalSlides; i++) {
      const dot = document.createElement("button");
      dot.classList.add("custom-dot");
      if (i === 0) dot.classList.add("active");
      dot.addEventListener("click", () => goToSlide(i));
      dotsContainer.appendChild(dot);
    }
  }

  // Update slide position with smooth animation
  function updateSlidePosition(animate = true) {
    if (animate) {
      track.classList.add("transitioning");
      isAnimating = true;

      // Auf transitionEnd hören, anstatt künstlichen Timeout
      const onTransitionEnd = () => {
        track.classList.remove("transitioning");
        isAnimating = false;
        track.removeEventListener("transitionend", onTransitionEnd);
      };

      track.addEventListener("transitionend", onTransitionEnd, { once: true });
    } else {
      track.classList.remove("transitioning");
    }

    const translateX = -currentSlide * 100;
    track.style.transform = `translateX(${translateX}%)`;
  }

  // Go to specific slide
  function goToSlide(index) {
    if (isAnimating || index === currentSlide) return;

    // Update dots
    document.querySelectorAll(".custom-dot").forEach((dot) => dot.classList.remove("active"));
    document.querySelectorAll(".custom-dot")[index].classList.add("active");

    currentSlide = index;
    updateSlidePosition(true);
    updateButtons();
  }

  // Go to next slide
  function nextSlide() {
    if (isAnimating) return;
    const next = (currentSlide + 1) % totalSlides;
    goToSlide(next);
  }

  // Go to previous slide
  function prevSlide() {
    if (isAnimating) return;
    const prev = (currentSlide - 1 + totalSlides) % totalSlides;
    goToSlide(prev);
  }

  // Update button states (optional - can disable buttons at ends)
  function updateButtons() {
    // For infinite loop, buttons are always enabled
    // Uncomment below for non-infinite behavior:
    // prevBtn.disabled = currentSlide === 0;
    // nextBtn.disabled = currentSlide === totalSlides - 1;
  }

  // Event listeners
  if (prevBtn) {
    prevBtn.addEventListener("click", prevSlide);
  }

  if (nextBtn) {
    nextBtn.addEventListener("click", nextSlide);
  }

  // Keyboard navigation
  document.addEventListener("keydown", function (e) {
    if (e.key === "ArrowLeft") prevSlide();
    if (e.key === "ArrowRight") nextSlide();
  });

  // Touch/Swipe support for mobile
  let startX = 0;
  let endX = 0;
  let isDragging = false;

  track.addEventListener(
    "touchstart",
    function (e) {
      if (isAnimating) return;
      startX = e.touches[0].clientX;
      isDragging = true;
    },
    {
      passive: true,
    },
  );

  track.addEventListener(
    "touchmove",
    function (e) {
      if (!isDragging || isAnimating) return;
      e.preventDefault();
    },
    {
      passive: false,
    },
  );

  track.addEventListener(
    "touchend",
    function (e) {
      if (!isDragging || isAnimating) return;

      endX = e.changedTouches[0].clientX;
      const diff = startX - endX;

      if (Math.abs(diff) > 50) {
        // Minimum swipe distance
        if (diff > 0) {
          nextSlide(); // Swipe left - next slide
        } else {
          prevSlide(); // Swipe right - previous slide
        }
      }

      isDragging = false;
    },
    {
      passive: true,
    },
  );

  // Prevent context menu on long press
  track.addEventListener("contextmenu", function (e) {
    e.preventDefault();
  });

  initCarousel();
});

//VIDEO LADEN
document.addEventListener("DOMContentLoaded", function () {
  // Quicklinks-Optimierung bleibt unverändert...

  // Verbesserte Video-Loading-Optimierung
  const videoContainers = document.querySelectorAll(".video-container");

  videoContainers.forEach((container) => {
    const thumbnailWrapper = container.querySelector(".video-thumbnail-wrapper");
    const videoUrl = container.dataset.videoUrl;
    let videoLoaded = false;

    // Event-Listener direkt auf dem Wrapper
    thumbnailWrapper.addEventListener("click", function (e) {
      // Verhindert Bubble-Up des Events
      e.preventDefault();
      e.stopPropagation();

      if (!videoLoaded) {
        // iframe erstellen und Video laden
        const iframe = document.createElement("iframe");
        iframe.src = videoUrl;
        iframe.className = "w-full aspect-video relative z-[6]";
        iframe.height = "555px";
        iframe.frameBorder = "0";
        iframe.allow = "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture";
        iframe.allowFullscreen = true;

        // Thumbnail durch Video ersetzen
        this.replaceWith(iframe);
        videoLoaded = true;
      }
    });
  });
});

// COOKIE ALERT
document.addEventListener("DOMContentLoaded", function () {
  "use strict";
  let cookieAlert = document.querySelector(".cookiealert");
  let acceptCookies = document.querySelector(".acceptcookies");

  // Prüfen, ob die Cookie-Alert-Elemente existieren
  if (!cookieAlert || !acceptCookies) {
    console.warn("Cookie-Alert-Elemente nicht gefunden");
    return;
  }

  // Nur anzeigen, wenn Cookie nicht gesetzt
  if (!getCookie("acceptCookies")) {
    cookieAlert.classList.add("show");
  }

  acceptCookies.addEventListener("click", function () {
    setCookie("acceptCookies", true, 60);
    cookieAlert.classList.remove("show");
  });
});

function setCookie(cname, cvalue, exdays) {
  let d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

// Akkordeon Funktionalität
document.addEventListener("DOMContentLoaded", function () {
  function initAccordionBlock(wrapper) {
    const accordionHeaders = wrapper.querySelectorAll(".accordion-header");
    const loadMoreBtn = wrapper.querySelector(".load-more-accordions");
    const showLessBtn = wrapper.querySelector(".show-less-accordions");
    const buttonContainer = wrapper.querySelector(".button-container");

    let accordionsPerLoad = 5;
    let currentlyVisible = 5;
    let totalAccordions = 0;

    if (buttonContainer) {
      accordionsPerLoad = parseInt(buttonContainer.dataset.accordionsPerLoad) || 5;
      currentlyVisible = parseInt(buttonContainer.dataset.initiallyVisible) || 5;
      totalAccordions = parseInt(buttonContainer.dataset.totalAccordions) || 0;
    }

    // Setze initiale max-height für aktive Elemente
    wrapper.querySelectorAll(".accordion-item.active .accordion-body").forEach((body) => {
      body.style.maxHeight = body.scrollHeight + "px";
    });

    // Mehr laden Funktionalität
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener("click", function () {
        const currentlyHidden = wrapper.querySelectorAll(".hidden-accordion");

        if (currentlyHidden.length === 0) return;

        const nextBatch = Array.from(currentlyHidden).slice(0, accordionsPerLoad);

        nextBatch.forEach((accordion, index) => {
          setTimeout(() => {
            accordion.style.display = "block";
            accordion.classList.add("showing");
            accordion.classList.remove("hidden-accordion");

            setTimeout(() => {
              accordion.classList.remove("showing");
            }, 400);
          }, index * 100);
        });

        currentlyVisible += nextBatch.length;

        if (currentlyVisible >= totalAccordions) {
          setTimeout(
            () => {
              loadMoreBtn.classList.add("fade-out");

              setTimeout(() => {
                loadMoreBtn.style.display = "none";
                showLessBtn.style.display = "block";

                setTimeout(() => {
                  showLessBtn.classList.add("fade-in");
                }, 50);
              }, 300);
            },
            nextBatch.length * 100 + 200,
          );
        }
      });
    }

    // Weniger anzeigen Funktionalität
    if (showLessBtn) {
      showLessBtn.addEventListener("click", function () {
        const allAccordions = wrapper.querySelectorAll(".accordion-item");
        const accordionsToHide = Array.from(allAccordions).slice(accordionsPerLoad);

        accordionsToHide.reverse().forEach((accordion, index) => {
          setTimeout(() => {
            accordion.classList.add("hiding");

            setTimeout(() => {
              accordion.style.display = "none";
              accordion.classList.remove("hiding");
              accordion.classList.add("hidden-accordion");
            }, 300);
          }, index * 80);
        });

        currentlyVisible = accordionsPerLoad;

        setTimeout(
          () => {
            showLessBtn.classList.remove("fade-in");
            showLessBtn.classList.add("fade-out");

            setTimeout(() => {
              showLessBtn.style.display = "none";
              showLessBtn.classList.remove("fade-out");

              setTimeout(() => {
                loadMoreBtn.style.display = "block";
                loadMoreBtn.classList.remove("fade-out");

                setTimeout(() => {
                  loadMoreBtn.classList.add("fade-in");
                }, 50);
              }, 200);
            }, 300);
          },
          accordionsToHide.length * 80 + 400,
        );
      });
    }

    // Akkordeon Funktionalität
    accordionHeaders.forEach((header) => {
      header.addEventListener("click", function () {
        const item = this.closest(".accordion-item");
        const body = item.querySelector(".accordion-body");
        const minusIcon = item.querySelector(".minus-icon");
        const plusIcon = item.querySelector(".plus-icon");
        const isActive = this.classList.contains("active");

        // Alle anderen in DIESEM Wrapper schließen
        wrapper.querySelectorAll(".accordion-item").forEach((otherItem) => {
          if (otherItem !== item) {
            const otherBody = otherItem.querySelector(".accordion-body");
            const otherHeader = otherItem.querySelector(".accordion-header");
            const otherMinus = otherItem.querySelector(".minus-icon");
            const otherPlus = otherItem.querySelector(".plus-icon");

            otherItem.classList.remove("active");
            otherHeader.classList.remove("active");

            otherBody.style.maxHeight = otherBody.scrollHeight + "px";
            otherBody.offsetHeight;
            otherBody.style.maxHeight = "0px";
            otherBody.classList.remove("active");

            otherMinus.classList.add("opacity-0", "hidden");
            otherMinus.classList.remove("opacity-100");
            otherPlus.classList.remove("opacity-0", "hidden");
            otherPlus.classList.add("opacity-100");
          }
        });

        // Aktuelles Item togglen
        if (isActive) {
          item.classList.remove("active");
          this.classList.remove("active");

          body.style.maxHeight = body.scrollHeight + "px";
          body.offsetHeight;
          body.style.maxHeight = "0px";
          body.classList.remove("active");

          minusIcon.classList.add("opacity-0", "hidden");
          minusIcon.classList.remove("opacity-100");
          plusIcon.classList.remove("opacity-0", "hidden");
          plusIcon.classList.add("opacity-100");
        } else {
          item.classList.add("active");
          this.classList.add("active");
          body.style.maxHeight = body.scrollHeight + "px";
          body.classList.add("active");

          plusIcon.classList.add("opacity-0", "hidden");
          plusIcon.classList.remove("opacity-100");
          minusIcon.classList.remove("opacity-0", "hidden");
          minusIcon.classList.add("opacity-100");
        }
      });
    });
  }

  // Alle Accordion-Wrapper initialisieren
  document.querySelectorAll(".accordion-wrapper").forEach(initAccordionBlock);
});
